import HotelList from "../components/HotelList";
import { Helmet } from "react-helmet-async";

export default function Hotels() {
    return (

        <>
            <Helmet>
                <title>
                    Hotels in Dubai | Jumeira Discount Hotels
                </title>

                <meta
                    name="description"
                    content="Browse cheap hotels, budget stays, apartments, and affordable accommodations in Dubai with Jumeira Discount Hotels."
                />

                <link
                    rel="canonical"
                    href="https://jumeiradiscounthotels.com/hotels"
                />

                {/* Open Graph */}
                <meta
                    property="og:title"
                    content="Hotels in Dubai | Jumeira Discount Hotels"
                />

                <meta
                    property="og:description"
                    content="Browse cheap hotels, budget stays, apartments, and affordable accommodations in Dubai with Jumeira Discount Hotels."
                />

                <meta
                    property="og:url"
                    content="https://jumeiradiscounthotels.com/hotels"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                {/* Twitter */}
                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="Hotels in Dubai | Jumeira Discount Hotels"
                />

                <meta
                    name="twitter:description"
                    content="Browse cheap hotels, budget stays, apartments, and affordable accommodations in Dubai with Jumeira Discount Hotels."
                />

                <meta
                    name="robots"
                    content="index, follow"
                />
            </Helmet>

            <div>
                <HotelList showSidebar={true} showBanner={true} showHeading={false} />
            </div>
        </>
    );
}